import React, { useEffect, createRef } from "react";
import Routes from "./routes";
import GlobalStyle from "./assets/styles/global";
import getDeviceType from "./helpers/userAgent";
import keycloak from './keycloak';
import {  KeycloakContext } from "./store/index";
import { refreshToken, logout } from './services/authentication';
import jwt from 'jsonwebtoken';
import ModalActionTimer from './components/ModalActionTimer';
import ModalInfoErrors from './components/ModalInfoErrors';
import colors from './assets/styles/colors';
import { BsExclamation } from 'react-icons/bs';
import { useIdleTimer } from 'react-idle-timer'

const App = ({ authenticated }) => {
  const ref = createRef();
  const refTime = createRef();
  var t;
  var timer;
  const timerSeconds = 4*60*1000;
  const globalWait = 16*60*1000;
  const {isIdle} = useIdleTimer({
    timeout: globalWait-10000,
    debounce: 500
  });

  function checkToken(){
    let session = JSON.parse(localStorage.getItem('@EC-session'));    
    if (session){
      const decoded = jwt.decode(session.token);
      if ((Date.now() >= (decoded.exp-5) * 1000)){
        clearTimeout(t);
        clearTimeout(timer); 
        cerrarSesion();
        return;
      }
      //se muestra el modal solamente cuando faltan cuatro minutos para vencer el token actual
      if (((decoded.exp * 1000) - Date.now()) <= timerSeconds){
        if (isIdle()){
          generateTimer();
          clearTimeout(t);
          t = setTimeout(checkToken, 244000);
        } else {
          refreshTokenSesion();  
        }        
      }else{
        clearTimeout(timer); 
        clearTimeout(t);
        let timeCalc = (decoded.exp * 1000) - Date.now() - timerSeconds;
        if (timeCalc < -timerSeconds){
          t = setTimeout(checkToken, 960000);
        }else{
          t = setTimeout(checkToken, timeCalc);
        }        
      }
    }else{
      clearTimeout(t);
      clearTimeout(timer); 
      cerrarSesion();
    }
    
  }

  function continuarSesion(){
    let session = JSON.parse(localStorage.getItem('@EC-session'));
    if (session){
      const decoded1 = jwt.decode(session.token);
      if ((Date.now() > decoded1.exp * 1000)){
        clearTimeout(t);
        clearTimeout(timer); 
        cerrarSesion();
        return;
      }      
      refreshToken(session.clientId, 'refresh_token', session.refreshToken)
      .then(() => {
        closeModal();
        clearTimeout(t);
        clearTimeout(timer);
        t = setTimeout(checkToken, globalWait);     
      }) 
      closeModal();     
    }else{      
      clearTimeout(timer); 
      clearTimeout(t);
      cerrarSesion();
    }
  }

  function cerrarSesion(){
    closeModal();
    logout(keycloak);
  }

  function refreshTokenSesion(){
    let session = JSON.parse(localStorage.getItem('@EC-session'));
    if (session){
      refreshToken(session.clientId, 'refresh_token', session.refreshToken)
      .then(() => {
        clearTimeout(t);
        clearTimeout(timer);
        t = setTimeout(checkToken, globalWait);     
      }) 
    } else{
      clearTimeout(t);
      clearTimeout(timer); 
      cerrarSesion();
    }
  }

 function closeModal(){
    ref.current.style.overflow='hidden';
    ref.current.style.height='';
    ref.current.style.opacity='0';
    ref.current.style.display='none';
 }

function generateTimer(){
    let distance = timerSeconds;
    clearTimeout(timer);
    let min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let sec = Math.floor((distance % (1000 * 60)) / 1000);
    distance = distance - 1000;
    refTime.current.innerHTML = String(min).padStart(2, '0') + ":" + String(sec).padStart(2, '0') + "s";      
    ref.current.style.overflow='';
    ref.current.style.height='auto';
    ref.current.style.opacity='1';
    ref.current.style.display='';
    const run = () => {      
      let min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let sec = Math.floor((distance % (1000 * 60)) / 1000);
      refTime.current.innerHTML = String(min).padStart(2, '0') + ":" + String(sec).padStart(2, '0') + "s";
      if (distance < 0) {
        clearTimeout(t);
        clearTimeout(timer);
        cerrarSesion();     
      } else {
        timer = setTimeout(run, 1000);
      }
      distance = distance - 1000;
    }
    timer = setTimeout(run, 1000);
  }

  useEffect(() => {
    if (
      getDeviceType() !== "desktop" &&
      window.location.pathname !== "/device"
    ) {
      window.location.replace("/device");
    }
    let session = JSON.parse(localStorage.getItem('@EC-session'));
    if (session){
      t = setTimeout(checkToken, globalWait);
    }
    
  }, []);

  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "jrg77zmyl5");
  }, []); 

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        alert("La impresión está deshabilitada en esta aplicación.");
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <KeycloakContext.Provider value={{ authenticated, keycloak }}>
      <Routes />
      <GlobalStyle />
      <ModalActionTimer
        ref={ref}
        refTime={refTime}
        actionFunctionUpButton={() => continuarSesion()}
        actionFunctionDownButton={() => cerrarSesion()}
        title="Tu sesión expira en:"
        actionLabelFunctionUpButton="Continuar con la sesión"
        actionLabelFunctionDownButton="Cerrar sesión"
        backgroundIcon={colors.bgTertiary}
        bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
      <ModalInfoErrors
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    </KeycloakContext.Provider>
  );
};

export default App;
